import { FormHelperText } from '@mui/material';
import React from 'react';
export const FormHelperErrorDescription = ({ error, description }) => {
    return (React.createElement(React.Fragment, null,
        error && (React.createElement(FormHelperText, { tabIndex: 0, "data-test": 'error' }, error)),
        description && (React.createElement(FormHelperText, { sx: { whiteSpace: 'pre-wrap' }, "data-test": 'description' }, description))));
};
